module.exports = __webpack_public_path__ + "img/b2f63f2.png";